import SidebarShell from "@/components/SidebarShell/SidebarShell.vue";
import SidebarContext from "@/components/SidebarContext/SidebarContext.vue";
import SidebarUserFooter from "@/components/SidebarUserFooter/SidebarUserFooter.vue";
import brand_details from "@/data/brand_details";
import get_sectors from "@/data/sectors";
import is_admin_user from "@/utils/auth_user";

// IMPORT UTILITIES
import { get_user_profile } from "@/router";

//Getting Company details
const details = brand_details();
const default_property_menu_item = "utilities";

export default {
  name: "PropertySidebar",

  components: {
    SidebarShell,
    SidebarContext,
    SidebarUserFooter
  },

  props: {
    active_property: {
      type: Object,
      required: true
    },
    properties: {
      type: Array,
      required: true
    },
    active_item: {
      type: String,
      default: default_property_menu_item
    },
    can_view_portfolio: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return ({
      // SECTORS SHOWN IN THE CONTEXT DROPDOWN
      sectors: get_sectors(),

      // MENU STATE
      active_menu_item: default_property_menu_item,
      dropdownOpen: false,

      //Sub Entity Details
      entity_name: details.sub_entity_name,
      entity_subtitle: details.sub_entity_subtitle,
      brand_name: details.name,
      brand_subtitle: details.subtitle,


      // FOOTER
      full_name: "Guest User",
      initials: "GU",
      is_admin: false,

      // BRAND LOGO
      bolide_short_logo: getComputedStyle(document.documentElement)
        .getPropertyValue("--brand-short-logo")
        .replace(/['"]+/g, "")
    });
  },

  computed: {
    can_access_portfolio() {
      return this.is_admin || this.can_view_portfolio;
    },

    propertiesFormatted() {
      return (this.properties || []).map(item => ({
        id: item.id,
        label: item.title,
        description: item.description,
        is_live: Boolean(item.is_live)
      }));
    },

     menuItems() {
      return [
        // --- UTILITIES ---
        { 
          key: "utilities", 
          label: "Utility Usage", 
          icon: "bi bi-droplet-half"
        },
        // --- OPERATIONS ---
        { 
          key: "operations-overview", 
          label: "Operations Hub", 
          icon: "bi bi-speedometer2" 
        },

        // --- ENERGY ---
        { 
          key: "energy", 
          label: "Energy Performance", 
          icon: "bi bi-plug-fill" 
        },

        // --- SAVINGS INSIGHTS ---
        { 
          key: "savings_insights", 
          label: "Cost Savings", 
          icon: "bi bi-piggy-bank-fill" 
        },
        {
          key: "turnover",
          label: "Turnover",
          icon: "bi bi-arrow-left-right"
        },
        {
          key: "profit-share",
          label: "Profit Share",
          icon: "bi bi-percent"
        },

        // --- SECURITY & CONNECTIVITY SPLIT ---
        { 
          key: "security", 
          label: "Site Security", 
          icon: "bi bi-shield-check" 
        },
        { 
          key: "connectivity", 
          label: "Network Status", 
          icon: "bi bi-router-fill" 
        },

        // --- INSIGHTS, RESOURCES, PARKING ---
        { 
          key: "insights-analytics", 
          label: "Performance Insights", 
          icon: "bi bi-activity" 
        },
        { 
          key: "resources", 
          label: "Property Files", 
          icon: "bi bi-archive-fill" 
        },
        // { 
        //   key: "parking-access", 
        //   label: "Parking & Access", 
        //   icon: "bi bi-car-front-fill" 
        // }
      ];
    }
  },

  mounted() {
    this.load_user_name();
    // Auto-select the first property menu item when PropertySidebar mounts
    this.active_menu_item = this.active_item;
  },

  watch: {
    active_item(newItem) {
      this.active_menu_item = newItem || default_property_menu_item;
    },

    active_property(newProperty) {
      // Auto-select the first property menu item when active property changes
      if (newProperty) {
        this.selectPropertyMenuItem(default_property_menu_item);
      }
    }
  },

  methods: {
    /** FOOTER NAME INITIALS */
    load_user_name() {
      const user = get_user_profile();
      let name = "Guest User";
      this.is_admin = is_admin_user(user);

      if (user && (user.first_name || user.last_name)) {
        name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      } else {
        const first = sessionStorage.getItem("first_name") || "";
        const last = sessionStorage.getItem("last_name") || "";
        name = `${first} ${last}`.trim() || "Guest User";
      }

      if (name === "Guest User" && user?.email) {
        name = user.email.split("@")[0];
      }

      const parts = name.split(" ");
      const initials = ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || "GU";

      this.full_name = name;
      this.initials = initials;
    },

    /** DROPDOWN LOGIC */
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    select_sector(sector) {
      this.dropdownOpen = false;
      this.$emit("select-sector", sector);
    },

    switchProperty(item) {
      this.dropdownOpen = false;

      this.$emit("switch-property", item.id);

      // reset to the first menu item
      this.active_menu_item = default_property_menu_item;
    },

    backToGlobal() {
      if (!this.can_access_portfolio) {
        return;
      }

      this.dropdownOpen = false;
      this.$emit("go-back");
    },

    /** MENU SELECTION LOGIC */
    selectPropertyMenuItem(menuItem) {
      this.active_menu_item = menuItem;

      this.$emit("property-menu-selected", {
        menuItem,
        propertyId: this.active_property.id,
        propertyName: this.active_property.title
      });
    }
  }
};
